export const navigate = () => {
  return null;
};
